import { Button, Card, Space, Table } from 'antd';
import React, { useState } from 'react';

import { AddOrEditModal } from './components/AddOrEditModal';
import { CategoryDetail } from './components/CategoryDetail';
import { DUMMY_TABLE_DATASOURCE } from './constants';
import { getTableColumns } from './helpers';
import styles from './index.module.scss';
import type { EdutainmentCategory, ModalType } from './types';

export const CategoryManagement = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<ModalType>(undefined);
  const [editingCategory, setEditingCategory] = useState<
    EdutainmentCategory | undefined
  >(undefined);

  const closeModal = () => {
    setModalType(undefined);
    setEditingCategory(undefined);
    setShowModal(false);
  };

  const handleEditButtonClick = (record: EdutainmentCategory) => {
    setModalType('form');
    setEditingCategory(record);
    setShowModal(true);
  };

  const handleDetailButtonClick = (record: EdutainmentCategory) => {
    setModalType('detail');
    setEditingCategory(record);
    setShowModal(true);
  };

  const columns = getTableColumns({
    handleEditButtonClick,
    handleDetailButtonClick,
  });

  return (
    <>
      <Space direction="vertical" className={styles['w-full']}>
        <Button
          onClick={() => {
            setModalType('form');
            setShowModal(true);
          }}
        >
          新增育樂類別
        </Button>
        <Card>
          <h4>育樂類別</h4>
          <Table
            bordered
            rowKey="_id"
            columns={columns}
            // TODO: 暫用假資料，待改成真實資料
            dataSource={DUMMY_TABLE_DATASOURCE}
            scroll={{ x: 'max-content' }}
          />
        </Card>
      </Space>
      {modalType === 'form' ? (
        <AddOrEditModal
          showModal={showModal}
          closeModal={closeModal}
          editingCategory={editingCategory}
        />
      ) : modalType === 'detail' ? (
        <CategoryDetail
          showModal={showModal}
          closeModal={closeModal}
          editingCategory={editingCategory}
        />
      ) : null}
    </>
  );
};
